import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    if (!email) {
      setStatus('error');
      return;
    }
    fetch(`${API_URL}/api/newsletter/unsubscribe/?email=${encodeURIComponent(email)}`)
      .then(res => {
        if (!res.ok) throw new Error();
        setStatus('success');
      })
      .catch(() => setStatus('error'));
  }, [email]);

  return (
    <div style={{ margin: 0, padding: 0, backgroundColor: '#f0f0f0', minHeight: '100vh', fontFamily: 'Arial, sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: 560, width: '100%', backgroundColor: '#ffffff', borderRadius: 6, overflow: 'hidden', margin: '40px 16px' }}>

        {/* Header */}
        <div style={{ backgroundColor: '#232566', padding: '28px 40px', textAlign: 'center' }}>
          <a href="https://readysetstem.org" style={{ textDecoration: 'none' }}>
            <img
              src="https://res.cloudinary.com/dfa8raimq/image/upload/v1775505304/RSS-000_Horizontal_1_lkbjgp.png"
              width="200"
              alt="Ready Set STEM"
              style={{ display: 'block', height: 'auto', margin: '0 auto' }}
            />
          </a>
        </div>

        {/* Body */}
        <div style={{ padding: '40px 40px 32px', textAlign: 'center' }}>
          {status === 'loading' && (
            <p style={{ color: '#555555', fontSize: 15 }}>Unsubscribing...</p>
          )}

          {status === 'success' && (
            <>
              <h1 style={{ color: '#232566', fontSize: 22, margin: '0 0 16px 0' }}>You've been unsubscribed.</h1>
              <p style={{ color: '#555555', fontSize: 15, lineHeight: 1.7, margin: '0 0 24px 0' }}>
                <strong>{email}</strong> has been removed from our newsletter. You won't receive any more emails from us.
              </p>
              <p style={{ color: '#888888', fontSize: 13, lineHeight: 1.6, margin: 0 }}>
                Changed your mind?{' '}
                <a href="https://www.readysetstem.org" style={{ color: '#232566', fontWeight: 700 }}>
                  Visit our website
                </a>{' '}
                to sign up again anytime.
              </p>
            </>
          )}

          {status === 'error' && (
            <>
              <h1 style={{ color: '#232566', fontSize: 22, margin: '0 0 16px 0' }}>Something went wrong.</h1>
              <p style={{ color: '#555555', fontSize: 15, lineHeight: 1.7, margin: '0 0 24px 0' }}>
                We couldn't process your request. Please email{' '}
                <a href="mailto:info@readysetstem.org" style={{ color: '#232566', fontWeight: 700 }}>
                  info@readysetstem.org
                </a>{' '}
                and we'll remove you manually.
              </p>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{ backgroundColor: '#1a1c4a', padding: '20px 40px', textAlign: 'center' }}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11, margin: 0 }}>
            Aurora | Naperville | Oswego | Plainfield, IL
          </p>
        </div>

      </div>
    </div>
  );
}
